import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import data from '../data/data.json'; // Impor JSON

const Galeri = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [kategori, setKategori] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const parallaxStyle = (speed, rotate) => ({
    transform: `translateY(${scrollPosition * speed}px) rotate(${rotate}deg)`,
  });

  const filteredImages = data.galeri.filter((image) =>
    kategori === 'all' ? true : image.kategori === kategori
  );

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const closePopup = () => {
    setSelectedImage(null);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closePopup();
    }
  };

  return (
    <Layout>
      <div
        className="flex flex-col justify-center items-center p-4 font-inter text-white transition-opacity duration-300"
        style={{ opacity: Math.max(0, 1 - scrollPosition / 400) }}
      >
        <h1 className="text-yellow-400 font-bold text-3xl lg:text-4xl mb-2">Galeri</h1>
        <h2 className="text-3xl text-cyan-600">Rumah Tahfidz An-Nuur</h2>
        <p className='mt-4 md:text-xl'>Galeri ini adalah bentuk apresiasi untuk setiap langkah kecil yang membawa manfaat besar. Saksikan dan bagikan keindahan perjuangan para santri bersama kami.</p>
      </div>

      <div className='flex justify-start lg:justify-center gap-2 md:gap-4 px-4 mb-4 overflow-hidden md:overflow-x-auto text-white'>
        {['all', 'prestasi', 'fasilitas', 'santri'].map((cat) => (
          <button
            key={cat}
            onClick={() => setKategori(cat)}
            className={`px-4 md:text-xl py-2 ${kategori === cat ? 'bg-yellow-500' : 'bg-cyan-600'} rounded-[90px]`}
          >
            {cat.charAt(0).toUpperCase() + cat.slice(1)}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 p-4 mb-[1200px] md:mb-[800px] lg:mb-[700px]">
        {filteredImages.map((image) => (
          <div
            key={image.id}
            className="h-[300px] sm:h-[400px] lg:h-[500px] w-full rounded-2xl bg-scroll bg-center bg-no-repeat bg-cover cursor-pointer"
            loading="lazy"
            style={{
              backgroundImage: `url(${image.url})`,
              ...parallaxStyle(image.speed, image.rotate),
            }}
            onClick={() => handleImageClick(image)}
          ></div>
        ))}
      </div>

      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
          onClick={handleOverlayClick}
        >
          <div className="relative bg-[#4781a3] rounded-lg shadow-lg max-w-4xl w-full p-6">
            <button
              className="absolute -top-1 right-1 text-white text-3xl font-bold"
              onClick={closePopup}
            >
              &times;
            </button>
            <img
              src={selectedImage.url}
              alt="Selected"
              className="w-full h-auto max-h-[70vh] object-contain rounded-md"
            />
            <div className="mt-4 text-center text-white">
              <h3 className="text-xl font-semibold">{selectedImage.nama_gambar}</h3>
              <p className="">Kategori: {selectedImage.kategori}</p>
              <p className="mt-2">{selectedImage.deskripsi_gambar}</p>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default Galeri;